module.exports = __webpack_public_path__ + "static/media/catalog-logo.325bdae5.svg";